import script from "./SectionHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SectionHeader.vue?vue&type=style&index=0&id=1d075e34&lang=scss"

const __exports__ = script;

export default __exports__